import { Controller } from "@hotwired/stimulus"

// Controlador Stimulus para gerenciar collapse de filtros
//
// Uso:
// 1. Adicione data-controller="filter-collapse" no container
// 2. Adicione data-filter-collapse-starts-expanded-value="true/false" para controlar estado inicial
// 3. Use data-filter-collapse-target="collapseElement" no elemento collapse
// 4. Use data-filter-collapse-target="toggleIcon" no ícone que deve rotacionar
// 5. Use data-action="click->filter-collapse#toggle" no elemento clicável
//
// Exemplo:
/*
<div data-controller="filter-collapse"
     data-filter-collapse-starts-expanded-value="true">
  <h5 data-action="click->filter-collapse#toggle">
    Filtros
    <i data-filter-collapse-target="toggleIcon" class="zmdi zmdi-chevron-down"></i>
  </h5>
  <div data-filter-collapse-target="collapseElement" class="collapse">
    <!-- Conteúdo do filtro -->
  </div>
</div>
*/

export default class extends Controller {
  static targets = ["collapseElement", "toggleIcon", "floatingExport"]
  static values = {
    startsExpanded: Boolean
  }

  connect() {
    // Inicializa o estado do collapse baseado no valor
    this.initializeCollapse()
  }

  initializeCollapse() {
    if (!this.hasCollapseElementTarget) return

    const collapseElement = this.collapseElementTarget

    // Define o estado inicial baseado no valor startsExpanded
    if (this.startsExpandedValue) {
      // Deve começar expandido
      collapseElement.classList.add('show')
      this.updateIconState(true)
    } else {
      // Deve começar colapsado
      collapseElement.classList.remove('show')
      this.updateIconState(false)
    }

    // Adiciona listeners para eventos do Bootstrap Collapse
    collapseElement.addEventListener('show.bs.collapse', () => {
      this.updateIconState(true)
    })

    collapseElement.addEventListener('hide.bs.collapse', () => {
      this.updateIconState(false)
    })

    // Força a sincronização após um pequeno delay para garantir
    // que o Bootstrap já inicializou
    setTimeout(() => {
      const isExpanded = collapseElement.classList.contains('show')
      this.updateIconState(isExpanded)
    }, 100)
  }

  updateIconState(isExpanded) {
    if (this.hasToggleIconTarget) {
      const icon = this.toggleIconTarget

      if (isExpanded) {
        icon.classList.add('rotated')
      } else {
        icon.classList.remove('rotated')
      }
    }

    // Atualiza visibilidade do botão flutuante de exportar
    this.updateFloatingExportVisibility(isExpanded)
  }

  updateFloatingExportVisibility(isExpanded) {
    if (!this.hasFloatingExportTarget) return

    const floatingExport = this.floatingExportTarget

    if (isExpanded) {
      // Collapse está aberto, esconde o botão flutuante
      floatingExport.classList.remove('visible')
    } else {
      // Collapse está fechado, mostra o botão flutuante
      floatingExport.classList.add('visible')
    }
  }

  toggle() {
    // Este método pode ser usado se quisermos controlar o toggle manualmente
    // Por enquanto, deixamos o Bootstrap Collapse lidar com isso via data-bs-toggle
  }
}
